import React from 'react';
import type { PreloadedQuery } from 'react-relay';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { CustomerExperiencesListQuery } from './__generated__/CustomerExperiencesListQuery.graphql';
import { CustomerExperiencesList } from './CustomerExperiencesList.tsx';
import { ViewAllExperiencesMenuItem } from './ViewAllExperiencesMenuItem.tsx';

export const CustomerExperiencesExpandableMenu = ({
	queryReference,
}: {
	queryReference: PreloadedQuery<CustomerExperiencesListQuery> | null;
}): React.JSX.Element => {
	return (
		<>
			<MenuListItem>
				<MenuSection>
					<MenuList>
						<Placeholder
							name="nav4.sidebar.customer-service.customer-experiences"
							fallback={<SkeletonNavMenuItems count={5} />}
						>
							{queryReference ? (
								<CustomerExperiencesList queryReference={queryReference} />
							) : (
								<SkeletonNavMenuItems count={5} />
							)}
						</Placeholder>
					</MenuList>
				</MenuSection>
			</MenuListItem>
			<ViewAllExperiencesMenuItem />
		</>
	);
};
